module.exports = __webpack_public_path__ + "static/media/laptop-care-whitelabel.76489c9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/asyst/laptop-care-whitelabel.png
// module id = 836
// module chunks = 0